import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class IntegardorFinx extends CoreBase implements IIntegradorFinx {
  async getAllClientes(): Promise<ResponseApi> {
    return Apis.IntegradorFinxApi.getAllClientes()
  }

  async getIntegracoesByClienteKey(clienteKey: string): Promise<ResponseApi> {
    return Apis.IntegradorFinxApi.getIntegracoesByClienteKey(clienteKey)
  }
}

interface IIntegradorFinx extends ICoreBase {
  getAllClientes(): Promise<ResponseApi>
  getIntegracoesByClienteKey(clienteKey: string): Promise<ResponseApi>
}

export {
  IIntegradorFinx,
  IntegardorFinx,
}
